import { ScopeHooks } from "sockapi/scope-specs";
import { ScopeType } from "sockapi/scope-types";

export enum PublicSubmissionType {
  PUBLIC_CUSTOM_PUZZLE = "public_custom_puzzle",
  PRIVATE_CUSTOM_PUZZLE = "private_custom_puzzle",
}

export type PublicSubmissionSummary = {
  type: PublicSubmissionType;
  teamId: string;
  respondTime: number;
  displayName?: string;
};

export type PublicSubmissionsScopeSpec = {
  state: {
    submissions: {
      [submissionId: string]: PublicSubmissionSummary;
    };
  };
};

export const publicSubmissionsScopeHooks: ScopeHooks<ScopeType.PUBLIC_SUBMISSIONS> =
  {
    identityFunc: (scope) => scope,
  };
